import internalServerErrorImg from '@assets/status-pages/internal_server_error.webp';
import { INTERNAL_SERVER_ERROR_STATUS_CODE } from '@constants/api.ts';
import { useLingui } from '@lingui/react/macro';
import StatusPage from '@routes/system/___shared___/components/status-page';
import { Text } from '@routes/system/___shared___/components/status-page/styled.tsx';

// TODO: display Error ID when provided from back-end

const InternalServerError = () => {
    const { t } = useLingui();

    return (
        <StatusPage
            image={<img src={internalServerErrorImg} alt={t`server error`} />}
            header={String(INTERNAL_SERVER_ERROR_STATUS_CODE)}
            subheader={t`Internal Server Error!`}
            content={<Text>{t`Something went wrong. We’re working to fix it.`}</Text>}
            useCallbackUrlForBackButton
        />
    );
};

export default InternalServerError;
